export const headers = [
  { field: "id", headerName: "ID", hidden: true },
  {
    field: "codigo",
    headerName: "Codigo",
    minWidth: 200,
  },
  {
    field: "descripcion",
    headerName: "Descripcion",
    minWidth: 200,
  },
  ];
  